$(document).on('click', '.abrirFormularioBuilder', function () {
    const eventoId = $(this).data('id');

    $('#contenido-formulario-builder').html('<p>Cargando...</p>');
    $('#modal-formdinamico').fadeIn();

    $.get('/admin/eventos/' + eventoId + '/formulario', function (html) {
        $('#contenido-formulario-builder').html(html);
        // 🔥 Si existe un formulario precargado en el Blade, reconstruimos los campos
        if (typeof estructuraPrecargada !== 'undefined' && Array.isArray(estructuraPrecargada)) {
            estructuraPrecargada.forEach(function(campo) {
                const id = contador++;
                const isBloqueado = ['politica', 'comunicaciones', 'firma'].includes(campo.tipo);
                const isIframe =  ['html-iframe'].includes(campo.tipo);
                //

                const campoHtml = `
                <div class="bloque-campo bg-white border rounded p-3 mb-3 shadow-sm" data-id="${id}">
                    <div class="row g-2 align-items-center">
                        <div class="col-md-3">
                            <label class="form-label">Tipo</label>
                            <select class="form-select tipo">
                                <option value="texto" ${campo.tipo === 'texto' ? 'selected' : ''}>Texto</option>
                                <option value="email" ${campo.tipo === 'email' ? 'selected' : ''}>Email</option>
                                <option value="select" ${campo.tipo === 'select' ? 'selected' : ''}>Select</option>      
                                <option value="number" ${campo.tipo === 'number' ? 'selected' : ''}>Número</option>
                                <option value="date" ${campo.tipo === 'date' ? 'selected' : ''}>Fecha</option>
                                <option value="textarea" ${campo.tipo === 'textarea' ? 'selected' : ''}>Área de texto</option>
                                <option value="checkbox" ${campo.tipo === 'checkbox' ? 'selected' : ''}>Casilla (Sí/No)</option>
                                <option value="politica" ${campo.tipo === 'politica' ? 'selected' : ''}>Política privacidad</option>
                                <option value="comunicaciones" ${campo.tipo === 'comunicaciones' ? 'selected' : ''}>Comunicaciones</option>
                                <option value="firma" ${campo.tipo === 'firma' ? 'selected' : ''}>Firma</option>
                                <option value="file-img" ${campo.tipo === 'file-img' ? 'selected' : ''}>Imagen (PNG/JPG, máx 4MB)</option>
                                <option value="file-video" ${campo.tipo === 'file-video' ? 'selected' : ''}>Vídeo (MP4, máx 4MB)</option>
                                <option value="html-iframe" ${campo.tipo === 'html-iframe' ? 'selected' : ''}>Contenido embebido (iframe)</option>

                            </select>
                        </div>
                        <div class="col-md-3 grupo-nombre" style="">
                            <label class="form-label">Nombre</label>
                            <input type="text" class="form-control nombre" value="${campo.nombre}" ${isBloqueado ? 'disabled' : ''}>
                        </div>
                        <div class="col-md-3 grupo-etiqueta" style="">
                            <label class="form-label">Etiqueta</label>
                            <input type="text" class="form-control etiqueta" value="${campo.etiqueta}" ${isBloqueado || isIframe ? 'disabled' : ''}>
                        </div>
                        <div class="col-md-2">
                            <label class="form-label w-100 text-center">¿Req?</label>
                            <div class="d-flex align-items-center justify-content-center">
                                <input type="checkbox" class="form-check-input requerido"  ${campo.requerido ? 'checked' : ''} ${campo.tipo === 'html-iframe' || campo.tipo === 'firma' || campo.tipo === 'politica' ? 'disabled' : ''}>
                            </div>
                        </div>
                        <div class="col-md-1 d-flex flex-column align-items-center justify-content-center">
                            <span class="drag-handle" style="cursor: move; font-size: 1.2rem;">☰</span>
                            <button type="button" class="btn btn-outline-danger btn-sm eliminar-campo" title="Eliminar campo">
                                &times;
                            </button>
                        </div>
                    </div>
                    <div class="row mt-3 opciones-wrap" style="${campo.tipo === 'select' ? '' : 'display:none;'}">
                        <div class="col-12">
                            <label class="form-label">Opciones (separadas por coma)</label>
                            <input type="text" class="form-control opciones" value="${campo.opciones ? campo.opciones.join(', ') : ''}">
                        </div>
                    </div>
                </div>`;

                $('#campos-contenedor').append(campoHtml);
            });

            recolectarCampos();
        }

        if ($('#campos-contenedor').length) {
            $('#campos-contenedor').sortable({
                handle: '.drag-handle',
                placeholder: "ui-state-highlight",
                forcePlaceholderSize: true,
                update: function (event, ui) {
                    recolectarCampos();
                    ui.item.stop().css('background', '#ffe0c2')
                        .animate({ backgroundColor: '#ffffff' }, 800);
                }
            });
        }
    });    
});
$(document).on('click', '.cerrar-modal-formulario', function () {
    $('#modal-formdinamico').fadeOut();
});
$(document).on('submit', '#form-builder', function (e) {
    e.preventDefault(); // Bloqueamos el envío normal

    let errores = [];

    // Limpiar errores visuales anteriores
    $('.bloque-campo input, .bloque-campo select').removeClass('is-invalid');

    // Validar
    $('.bloque-campo').each(function () {
        const nombreInput = $(this).find('.nombre');
        const etiquetaInput = $(this).find('.etiqueta');

        const nombre = nombreInput.val().trim();
        const etiqueta = etiquetaInput.val().trim();

        if (!nombre) {
            nombreInput.addClass('is-invalid');
            errores.push('Todos los campos deben tener un nombre.');
        }
        if (!etiqueta) {
            etiquetaInput.addClass('is-invalid');
            errores.push('Todos los campos deben tener una etiqueta.');
        }
    });

    if (errores.length > 0) {
        Swal.fire(
            'Error',
            errores.join('<br>'),
            'error'
        );
        return;
    }

    // ✅ Si todo está correcto, ahora sí recolectamos
    recolectarCampos();

    // Y enviamos el formulario manualmente
    this.submit();
});
$(document).on('change', '.bloque-campo input, .bloque-campo select', function () {
    recolectarCampos(); // actualiza preview en tiempo real
});
$(document).on('input', '.bloque-campo input', function () {
    if ($(this).val().trim() !== '') {
        $(this).removeClass('is-invalid');
    }
});

let contador = 0;
// Agregar nuevo campo
$(document).on('click','#agregar-campo', function () {
    const id = contador++;
    const campoHtml = `
    <div class="bloque-campo bg-white border rounded p-3 mb-3 shadow-sm" data-id="${id}">
        <div class="row g-2 align-items-center">
            <div class="col-md-3">
                <label class="form-label">Tipo</label>
                <select class="form-select tipo">
                    <option value="texto">Texto</option>
                    <option value="email">Email</option>
                    <option value="select">Select</option>
                    <option value="number">Número</option>
                    <option value="date">Fecha</option>
                    <option value="textarea">Área de texto</option>
                    <option value="checkbox">Casilla (Sí/No)</option>
                    <option value="politica">Política privacidad</option>
                    <option value="comunicaciones">Comunicaciones</option>
                    <option value="firma">Firma</option>
                    <option value="file-img">Imagen (PNG/JPG, máx 4MB)</option>
                    <option value="file-video">Vídeo (MP4, máx 4MB)</option>
                    <option value="html-iframe">Contenido embebido (iframe)</option>

                </select>
            </div>
            <div class="col-md-3">
                <label class="form-label">Nombre</label>
                <input type="text" class="form-control nombre">
            </div>
            <div class="col-md-3">
                <label class="form-label">Etiqueta</label>
                <input type="text" class="form-control etiqueta">
            </div>
            <div class="col-md-2">
                <label class="form-label w-100 text-center">¿Req?</label>
                <div class="d-flex align-items-center justify-content-center">
                    <input type="checkbox" class="form-check-input requerido">
                </div>
            </div>
            <div class="col-md-1 d-flex flex-column align-items-center justify-content-center">
                <span class="drag-handle" style="cursor: move; font-size: 1.2rem;">☰</span>
                <button type="button" class="btn btn-outline-danger btn-sm eliminar-campo" title="Eliminar campo">
                    &times;
                </button>
            </div>
        </div>
    
        <div class="row mt-3 opciones-wrap" style="display:none;">
            <div class="col-12">
                <label class="form-label">Opciones (separadas por coma)</label>
                <input type="text" class="form-control opciones" placeholder="Ej: Opción 1, Opción 2">
            </div>
        </div>
    </div>`;
    
    $('#campos-contenedor').append(campoHtml);
});
// Mostrar/ocultar opciones si el tipo es select
$(document).on('change', '.tipo', function () {
    const wrap = $(this).closest('.bloque-campo');
    const tipo = $(this).val();
    const isBloqueado = ['politica', 'comunicaciones', 'firma', 'html-iframe'].includes(tipo);
    // Si es un campo bloqueado, desmarcar y deshabilitar "requerido"
    const requeridoInput = wrap.find('.requerido');
    if (isBloqueado) {
        requeridoInput.prop('checked', false).prop('disabled', true);
    } else {
        requeridoInput.prop('disabled', false);
    }

    // Mostrar u ocultar campos personalizados
    wrap.find('.nombre').prop('readonly', isBloqueado).prop('disabled', isBloqueado);
    wrap.find('.etiqueta').prop('readonly', isBloqueado).prop('disabled', isBloqueado);

    // Mostrar/ocultar opciones si el tipo es select
    if (tipo === 'select') {
        wrap.find('.opciones-wrap').show();
    } else {
        wrap.find('.opciones-wrap').hide();
    }

    // Autocompletar valores si corresponde
    if (tipo === 'politica') {
        wrap.find('.nombre').val('politica');
        wrap.find('.etiqueta').val('Acepto la política de privacidad');
    } else if (tipo === 'comunicaciones') {
        wrap.find('.nombre').val('comunicaciones');
        wrap.find('.etiqueta').val('Acepto recibir comunicaciones');
    } else if (tipo === 'firma') {
        wrap.find('.nombre').val('firma');
        wrap.find('.etiqueta').val('Firma del tutor');
    }else if (tipo === 'file-img') {
        wrap.find('.nombre').val('imagen');
        wrap.find('.etiqueta').val('Sube tu imagen');
    }
    else if (tipo === 'file-video') {
        wrap.find('.nombre').val('video');
        wrap.find('.etiqueta').val('Sube tu vídeo');
    }
    else if (tipo === 'html-iframe') {
        wrap.find('.etiqueta').val('Sube tu vídeo');
        // Sustituir input por textarea si es iframe
        const nombreInput = wrap.find('.nombre');
        const valorActual = nombreInput.val() || '';
        if (!nombreInput.is('textarea')) {
            nombreInput.replaceWith(`<textarea class="form-control nombre" rows="3">${valorActual}</textarea>`);;
        }
    } else {
        wrap.find('.nombre').val('');
        wrap.find('.etiqueta').val('');
    }
});
// Eliminar campo
$(document).on('click', '.eliminar-campo', function () {
    $(this).closest('.bloque-campo').remove();
});
// Al enviar el formulario: construir JSON
$('#form-builder').on('submit', function (e) {
    const campos = [];

    $('.bloque-campo').each(function () {
        const tipo = $(this).find('.tipo').val();
        const nombre = $(this).find('.nombre').val();
        const etiqueta = $(this).find('.etiqueta').val();
        const requerido = $(this).find('.requerido').is(':checked');
        const opcionesTexto = $(this).find('.opciones').val();

        const campo = { tipo, nombre, etiqueta, requerido };

        if (tipo === 'select' && opcionesTexto.trim() !== '') {
            campo.opciones = opcionesTexto.split(',').map(op => op.trim());
        }

        campos.push(campo);
    });

    $('#estructura-json').val(JSON.stringify(campos));
});



function actualizarPrevisualizacion(campos) {
    const preview = $('#form-preview');
    preview.empty();

    campos.forEach(campo => {
        const group = $('<div class="mb-3"></div>');
        const label = $('<label></label>').text(campo.etiqueta || campo.nombre);
        
        let input;

        if (['texto', 'email', 'number', 'date'].includes(campo.tipo)) {
            group.append(label);
            input = $('<input>')
                .attr('type', campo.tipo)
                .attr('placeholder', campo.nombre)
                .addClass('form-control');
        } else if (campo.tipo === 'select') {
            group.append(label);
            input = $('<select></select>').addClass('form-select');
            (campo.opciones || []).forEach(op => {
                input.append(`<option>${op}</option>`);
            });
        } else if (campo.tipo === 'textarea') {
            group.append(label);
            input = $('<textarea>')
                .attr('placeholder', campo.nombre)
                .addClass('form-control');
        } else if (campo.tipo === 'checkbox') {
            input = $('<div class="form-check"><input type="checkbox" class="form-check-input"></div>');
        } else if (campo.tipo === 'politica') {
            input = $('<div class="form-check"><input type="checkbox" class="form-check-input" disabled><label class="form-check-label ms-2">He leido y acepto la <a href="/politica-privacidad">política de privacidad</a></label></div><div style="text-align:justify; margin-top:2rem; margin-bottom:2rem;">Le informamos que, en cumplimiento de la Normativa Europea de Protección de Datos (RGPD). sus datos de carácter personal serán tratados por parte de C.B.PROCOMUNALES DE NUEVO CENTRO, en calidad de responsable del tratamiento con la finalidad de la inscripción y participación en las actividades organizadas por el centro comercial. Salvo obligación legal o consentimiento expreso por su parte, C.B.PROCOMUNALES DE NUEVO CENTRO no va a ceder sus datos a terceras personas o entidades, a excepción de empresas colaboradoras en la actividad y organización para el correcto desarrollo de la misma. Durante la actividad o entrega de premios pueden recogerse imágenes para promoción de la misma actividad en web o redes sociales propiedad de Nuevo Centro o empresas organizadoras, dado el volumen de participantes en algunas actividades, se hace inviable la discriminación de imágenes y es requisito indispensable para la aceptación de la inscripción. Podrá acceder, rectificar o suprimir sus datos como disponer de otros derechos recogidos por la normativa de la forma que se explica en la información adicional. La información adicional detallada sobre protección de datos podrá ser consultada en nuestra página web www.nuevocentro.es Ud., se declara informado, consiente y, mediante la firma o aceptación del formulario de inscripción de la actividad de la web del presente documento autoriza al tratamiento de sus datos con la finalidad arriba indicada.</div>');
        } else if (campo.tipo === 'comunicaciones') {
            input = $('<div style="text-align:justify; margin-top:2rem; margin-bottom:2rem;">Asimismo, solicito su autorización para ofrecerle información sobre eventos o actividades relacionadas con C.B. PROCOMUNALES DE NUEVO CENTRO.</div><div class="form-check"><input type="checkbox" class="form-check-input" disabled><label class="form-check-label ms-2">ACEPTO RECIBIR NOVEDADES, COMUNICACIONES Y PROMOCIONES DE NUEVO CENTRO</label></div>');
        } else if (campo.tipo === 'firma') {
            input = $('<div><div class="text-muted mt-1">Firma del padre/madre/tutor legal</div><canvas width="200" height="80" style="border:1px solid #ccc;"></canvas></div>');
        }else if (campo.tipo === 'file-img') {
            group.append(label);
            input = $('<input type="file" accept="image/png,image/jpeg" class="form-control">');
        }
        else if (campo.tipo === 'file-video') {
            group.append(label);
            input = $('<input type="file" accept="video/mp4" class="form-control">');
        }
        else if (campo.tipo === 'html-iframe') {
            group.append(label);
            input = $('<div class="ratio ratio-16x9 mt-2"><iframe src="' + (campo.nombre || '') + '" frameborder="0" allowfullscreen></iframe></div>');
        }


        if (input) {
            group.append(input);
            preview.append(group);
        }
    });
}


function recolectarCampos() {
    const campos = [];

    $('.bloque-campo').each(function () {
        const tipo = $(this).find('.tipo').val();
        const nombre = $(this).find('.nombre').val();
        const etiqueta = $(this).find('.etiqueta').val();
        const requerido = $(this).find('.requerido').is(':checked');
        const opcionesTexto = $(this).find('.opciones').val();

        const campo = { tipo, nombre, etiqueta, requerido };

        if (tipo === 'select' && opcionesTexto.trim() !== '') {
            campo.opciones = opcionesTexto.split(',').map(op => op.trim());
        }

        campos.push(campo);
    });

    $('#estructura-json').val(JSON.stringify(campos));
    actualizarPrevisualizacion(campos);
}